import { PermissionEnum } from '@creditsights/api-ui-web';
import { ROUTES, USER_ROUTES } from '../../Base.constants';
import useFetchUserPermissions from '../permissions/useFetchUserPermissions';
import useFetchUserProfile from '../profile/useFetchUserProfile';

interface UseGetUserDropdownOptionsResult {
  userDropdownOptions: Array<{
    link?: string;
    title: string;
    dataTestId?: string;
    isEnabled?: boolean;
    isSeparated?: boolean;
    onClick?: () => void;
  }>;
}

export default (): UseGetUserDropdownOptionsResult => {
  const { data: userPermissions } = useFetchUserPermissions();
  const { data: profile } = useFetchUserProfile();

  const userDropdownOptions = [
    { dataTestId: 'profile-link', link: `${ROUTES.user}/${USER_ROUTES.profile}`, title: 'Profile' },
    {
      dataTestId: 'email-pref-link',
      link: `${ROUTES.user}/${USER_ROUTES.emailPreferences}`,
      title: 'Email Preferences',
      isEnabled: userPermissions?.hasAccessToStandardAlerts(),
    },
    {
      dataTestId: 'user-management',
      link: `${ROUTES.userManagement}`,
      title: 'User Admin',
      isEnabled: userPermissions?.permissions.includes(PermissionEnum.UI_ADMIN_USER_ADMIN),
    },
    {
      dataTestId: 'logout-link',
      link: `${ROUTES.logout}`,
      title: 'Logout',
      isSeparated: true,
    },
  ];
  return {
    userDropdownOptions: userPermissions && profile?.active ? [...userDropdownOptions] : [userDropdownOptions[3]],
  };
};
